var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.25,
    height: 13.5,
    viewBox: "0 0 20.25 13.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message",
    transform: "translate(0 -80.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2183",
    "data-name": "Group 2183",
    transform: "translate(0 80.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M18.47,80.609H1.78A1.758,1.758,0,0,0,0,82.341V92.377a1.758,1.758,0,0,0,1.78,1.732H18.47a1.758,1.758,0,0,0,1.78-1.732V82.341A1.758,1.758,0,0,0,18.47,80.609Zm-.232,1.155L18,81.956l-7.169,5.809a1.127,1.127,0,0,1-1.412,0L2.25,81.956l-.238-.192ZM1.187,82.6,7.028,87.33,1.187,91.113ZM18.47,92.954H1.78a.59.59,0,0,1-.581-.462L7.979,88.1l.68.551a2.339,2.339,0,0,0,2.931,0l.68-.551,6.781,4.391A.59.59,0,0,1,18.47,92.954Zm.593-1.841L13.222,87.33,19.063,82.6Z",
    transform: "translate(0 -80.609)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8d5b2e2d230c8b54e45bfd51d013b08c.svg";
export { ForwardRef as ReactComponent };